import BlogIcon from '../../public/platforms/Blog.svg';
import InstagramIcon from '../../public/platforms/instagram.svg';
import LinkedInIcon from '../../public/platforms/linkedin.svg';
import MediumIcon from '../../public/platforms/Medium.svg';
import SnapchatIcon from '../../public/platforms/Snapchat.svg';
import SpotifyIcon from '../../public/platforms/Spotify.svg';
import TikTokIcon from '../../public/platforms/tiktok.svg';
import TwitchIcon from '../../public/platforms/Twitch.svg';
import TwitterIcon from '../../public/platforms/X.svg';
import YouTubeIcon from '../../public/platforms/youtube.svg';

export const PlatformsList = [
  {
    label: 'Instagram',
    value: 'INSTAGRAM',
    type: 'social_network',
    icon: InstagramIcon
  },
  {
    label: 'TikTok',
    value: 'TIKTOK',
    type: 'social_network',
    icon: TikTokIcon
  },
  {
    label: 'YouTube',
    value: 'YOUTUBE',
    type: 'social_network',
    icon: YouTubeIcon
  },
  {
    label: 'Twitch',
    value: 'TWITCH',
    type: 'social_network',
    icon: TwitchIcon
  },
  {
    label: 'Twitter',
    value: 'TWITTER',
    type: 'social_network',
    icon: TwitterIcon
  },
  {
    label: 'Snapchat',
    value: 'SNAPCHAT',
    type: 'social_network',
    icon: SnapchatIcon
  },
  {
    label: 'LinkedIn',
    value: 'LINKEDIN',
    type: 'social_network',
    icon: LinkedInIcon
  },
  {
    label: 'Spotify',
    value: 'SPOTIFY',
    type: 'social_network',
    icon: SpotifyIcon
  },
  {
    label: 'Medium',
    value: 'MEDIUM',
    type: 'blog',
    icon: MediumIcon
  },
  {
    label: 'Blog',
    value: 'BLOG',
    type: 'blog',
    icon: BlogIcon
  }
];

export const filteredPlatformsList = PlatformsList.map(({ icon, ...rest }) => rest);
